import {
  FORM_ELEMENT_EMAIL,
  FORM_ELEMENT_FIRST_NAME,
  FORM_ELEMENT_LAST_NAME,
} from 'constants/FormConstants';
import {
  TABLE_ELEMENT_CREATED_AT,
  TABLE_ELEMENT_LAST_ACTIVE_AT,
  TABLE_ELEMENT_SEARCH_TERM,
  TABLE_INITIAL_ROWS_NUMBER,
} from 'constants/TableConstants';
import { TableSettingsType } from 'hooks/useTable';

const partnerUsersTableSettings: TableSettingsType = {
  initialRowsNumber: TABLE_INITIAL_ROWS_NUMBER,
  dataTestId: 'PartnerUsersTable',
  filter: [
    {
      field: TABLE_ELEMENT_SEARCH_TERM,
      title: 'filter.search',
      filterType: 'text',
    },
  ],
  columns: [
    {
      title: 'partnerUsers.firstName',
      field: FORM_ELEMENT_FIRST_NAME,
    },
    {
      title: 'partnerUsers.lastName',
      field: FORM_ELEMENT_LAST_NAME,
    },
    {
      title: 'partnerUsers.email',
      field: FORM_ELEMENT_EMAIL,
    },
    {
      title: 'partnerUsers.createdAt',
      field: TABLE_ELEMENT_CREATED_AT,
    },
    {
      title: 'partnerUsers.lastActiveAt',
      field: TABLE_ELEMENT_LAST_ACTIVE_AT,
    },
  ],
};

export default partnerUsersTableSettings;
